export const cardFooterCss = {
  display: "flex",
  alignContent: "space-around",
  justifyContent: "space-between",
  alignItems: "center",
};

export const cardFooterCssNoAssignButton = {
  ...cardFooterCss,
  justifyContent: "end",
};
